import Swiper from 'swiper';

export default function initCategoriesNav(): void {
    const $categoriesNav = document.querySelectorAll<HTMLElement>('.js-categories-nav-slider');

    $categoriesNav.forEach($container => {
        new CategoriesNav($container);
    });
}

class CategoriesNav {
    $el: HTMLElement | null | undefined;
    swiper: Swiper | null = null;
    mdBreakpoint: number;


    constructor($el: HTMLElement | null) {
        this.$el = $el;
        this.mdBreakpoint = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-md'));
        if (this.$el) {
            window.addEventListener('resize', this.onWindowResize.bind(this));
            this.onWindowResize();
        }
    }

    onWindowResize(): void {
        if (this.swiper && window.innerWidth > this.mdBreakpoint) {
            this.destroySwiper();
        } else if (!this.swiper && window.innerWidth <= this.mdBreakpoint) {
            this.createSwiper();
        }
    }


    createSwiper(): void {
        if (this.$el) {
            this.swiper = new Swiper(this.$el, {
                slidesPerView: 'auto',
                spaceBetween: 5,
                slidesOffsetAfter: 12,
            });
        }
    }

    destroySwiper(): void {
        this.swiper?.destroy(true, true);
        this.swiper = null;
    }
}
